/** @format */
import { Button, ButtonSize } from '@mpb-com/feather/components/atoms/button';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent, useEffect } from 'react';

import { useTooltip } from '@toucan/client/shared/hooks/use-tooltip';

import { DEFAULT_TEST_ID } from './constants';
import { useAddToBasketHandler } from './hooks/use-add-to-basket-handler';
import { ProductAddToBasketProps } from './types';

export const ProductAddToBasket: FunctionComponent<ProductAddToBasketProps> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    productData,
    size = ButtonSize.MEDIUM,
    ...otherProps
}) => {
    const { isLoading, handleAddToBasket, isErrorAddingToBasket, isInBasket } =
        useAddToBasketHandler(productData);

    const [bindTooltip, Tooltip, openTooltip] = useTooltip<HTMLButtonElement>({
        id: 'sold-product-buy-now',
        manual: true,
        closeOnClickAway: true,
    });

    const { t } = useTranslation();

    useEffect(() => {
        if (isErrorAddingToBasket) {
            openTooltip();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
    }, [isErrorAddingToBasket]);

    return (
        <Button
            {...otherProps}
            {...bindTooltip}
            data-testid={dataTestId}
            size={size}
            // eslint-disable-next-line @typescript-eslint/no-misused-promises -- Legacy code: do not use as an example.
            onClick={handleAddToBasket}
            isLoading={isLoading}
            disabled={isInBasket || isLoading}
        >
            {isInBasket ? t('Added to basket') : t('Add to basket')}
            <Tooltip className="tooltip">
                {t(
                    'There was a problem when trying to add this item to your basket'
                )}
            </Tooltip>
        </Button>
    );
};
